import React, { Fragment } from "react"
import footerLinks from "./links.json"
import styles from "./Footer.scss"

const createLinks = (links: Array<{ name: string; to: string }>) => {
  return links.map(({ name, to }) => (
    <a key={name} href={to}>
      {name}
    </a>
  ))
}

const Footer = () => (
  <div className={styles.container}>
    <div>
      <div>Liens utiles</div>
      <hr />
      <div>
        <div>{createLinks(footerLinks)}</div>
      </div>
      <div>©Copyright Allez Go ! Tous droits réservés.</div>
    </div>
  </div>
)

export default Footer
